import { useContext } from 'react'
import { PostHogContext, type PostHogParams } from '../context'

export function usePostHogParam() {
  return useContext<PostHogParams>(PostHogContext)
}
